import { DefectStatusEnum } from '../../enum/defect-status.enum';
import { ExternalMedia } from './external-media';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class EditInspectionDefectCommand {
  ScaffoldId: string;
  ScaffoldDiaryId: string;
  InspectionDefectId: string;
  DefectTypeId: string;
  DefectTypeFurtherInformation: string;
  Comments: string;
  DefectStatus: DefectStatusEnum;
  Media: ExternalMedia[];
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


